import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company info */}
          <div>
            <div className="mb-4">
              <span className="font-heading font-bold text-foreground-950 tracking-wide block text-base">
                DRAUDE & WAGNER
              </span>
              <span className="font-heading font-semibold tracking-widest text-primary-500 block text-sm">
                GALVANIK
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Ihr Spezialist für Metalloberflächenveredelung in Lüdenscheid. Seit vielen Jahren stehen wir für Qualität, Nachhaltigkeit und umweltbewusste Galvanik.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/qualitaet" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Qualität & Umwelt
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              Leistungen
            </h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-600">Verzinken</li>
              <li className="text-sm text-foreground-600">Phosphatieren</li>
              <li className="text-sm text-foreground-600">Brünieren</li>
              <li className="text-sm text-foreground-600">Trommelware</li>
              <li className="text-sm text-foreground-600">Gestellware</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-sm">
              Kontakt
            </h4>
            <address className="not-italic space-y-2.5 text-sm text-foreground-600">
              <p className="leading-relaxed">
                Draude & Wagner Galvanik<br />
                GmbH & Co. KG<br />
                Im Grund 11<br />
                58513 Lüdenscheid
              </p>
              <p>
                <Link to="/kontakt" className="text-primary-600 hover:text-primary-700 transition-colors font-medium">
                  Kontaktformular
                </Link>
              </p>
            </address>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Draude & Wagner Galvanik GmbH & Co. KG
          </p>
          <div className="flex items-center gap-4">
            <Link to="/impressum" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Impressum
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/datenschutz" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}